module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/readable-stream/writable-browser.js
// module id = 110
// module chunks = 0